import React from 'react'

const Welcome = () => {
  return (
    <div className="spacer">
        <h3>Welcome to Questify!!</h3>
        <p><br></br>Add tasks, edit them, mark them as completed or cancel them. We will list tasks according to priority and urgency(deadline less than 3 days away). All important tasks are listed first sorted according to urgency, then not important and urgent tasks and finally not important and not urgent tasks.<br/><br/>We hope your productivity is boosted and you can get all your tasks done using Questify. Design has been kept to a minimalistic level to avoid distractions.</p>
    </div>
  )
}

export default 
Welcome